import * as React from 'react';
import sanitizeHtml from 'sanitize-html';
import { IPost } from '../../types';

interface IProps {
	post: IPost;
}

const Wide = ({ post }: IProps) => {
	const linkText = 'Learn More';
	const isExternal =
		new URL(post.permalink, window.location.origin).host !== window.location.host;

	return (
		// We are correctly setting noreferrer and target="_blank" on external links.
		// eslint-disable-next-line react/jsx-no-target-blank
		<a
			href={post.permalink}
			className="pfa-card-wide"
			rel={isExternal ? 'noreferrer' : undefined}
			target={isExternal ? '_blank' : undefined}
		>
			<div className="pfa-card-wide__content">
				<span className="pfa-card-wide__tag">
					<p
						className="pfa-card-wide__tag-text"
						dangerouslySetInnerHTML={{ __html: sanitizeHtml(post.post_type_label) }}
					></p>
				</span>
				<h3
					className="pfa-card-wide__title"
					dangerouslySetInnerHTML={{ __html: sanitizeHtml(post.post_title) }}
				></h3>
			</div>
			<div className="pfa-card-wide__button-container">
				<div className="btn-tertiary pfa-card-wide__button">
					<div className="btn-frame">
						<span className="btn-inner">{linkText}</span>
					</div>
				</div>
			</div>
		</a>
	);
};

Wide.displayName = 'Wide';

export default Wide;
